import styled from "styled-components";

export const BenefitsWrapper = styled.div(
  (props) => `
  margin: 0 0 1.2rem 0;
  padding: 20px 26px 20px 15px;
  border-radius: 12px;
  background-color: #ffffff;
  `
);

export const Title = styled.span`
  font-family: 'Rubik';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #141823;
`;

export const FooterTitle = styled.div`
  font-family: 'Rubik';
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
  color: #2276E3;
  padding-top: 10px;
  cursor: pointer;
`

export const Outerwrapper = styled.ol`
  margin: 1.3rem 0.1rem 0.3rem 0.1rem;
`;

export const BenefitsLi = styled.li`
  list-style: none;
  margin: 0rem 0.1rem 0rem 0.1rem;
  flex-direction: row;
  display: flex;
`;

export const BenefitsTxt = styled.p`
  font-family: 'Rubik';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #141823;
  flex: 1;
  padding-left: 0.8rem;
`;
